import BaseService from '../baseServices';
import REST from '../../configs/rest';

function getWorkOrderReports(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }

  return BaseService.get(`${REST.REPORT_WORK_ORDER}${q}`);
}

function getContractReports(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }

  return BaseService.get(`${REST.REPORT_CONTRACT}${q}`);
}

function getUnitReports(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }

  return BaseService.get(`${REST.REPORT_UNIT}${q}`);
}

export default {
  getWorkOrderReports,
  getContractReports,
  getUnitReports,
};
